<template>
  <v-row class="py-1 px-5 grey lighten-4 fill-height">
    <v-col cols="12">
      <v-row>
        <v-col cols="12" SearchC>
          <Search 
            :loading="loading"
            :resourceSettings="resourceSettings" 
            @searchResource="searchResource" 
            @create="()=>{newResource = {}; dialog = true;}"
          />
        </v-col>
        <v-col cols="12" CustomPageActions>
          <v-card class="px-3" :loading="loading">
            <v-row class="pa-0">
              <v-col cols="6">
                <v-btn block text color="success" :loading="loading"
                  :class="`${arabic?'arFont':'enFont'}`"
                >
                  <v-icon left>sync</v-icon>
                  Custom
                </v-btn>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
        <v-col cols="12" PagingC>
          <Paging 
            :resourceSettings="resourceSettings" 
            :resource="resource"
            @loadResource="loadResource"
            @pageByNumber="pageByNumber"
          />
        </v-col>
        <v-col cols="12" Details>
          <v-card class="px-3" :loading="loading">
            <v-card-text>
              <v-row class="pa-0 align-center mb-1">
                <appointmentsListPanel
                  :resource="resource"
                  :resourceSettings="resourceSettings"
                  @editLead="editLead"
                  :loading="loading"
                  :resourceKeys="resourceKeys"
                />
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
        <multiDialog
          :dialog="dialog"
          :loading="loading"
          :resourceSettings="resourceSettings"
          :deleting="deleting"
          :resourceKeys="resourceKeys"
          :newResource="newResource"
          @closeDialog="()=>{dialog = false;newResource={};}"
          @deleteResource="deleteResource"
          @updateResource="updateResource"
          @postResource="postResource"
        />
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import Search from '@/components/Search'
import Paging from '@/components/Paging'
import multiDialog from '@/components/multiDialog'
import appointmentsListPanel from '@/components/appointmentsListPanel'
import { getRandomInt, randomString, getCDate, check, sleep } from '@/customFunction';
import { format, render, cancel, register } from 'timeago.js';
import axios from 'axios';
const headers = {'Accept': 'application/json'};
let api_fire_base = 'https://us-central1-aramcco-crm.cloudfunctions.net/main'

export default {
  components: { Search, Paging, multiDialog, appointmentsListPanel },
  data() {
    return {
      loading:false,
      dialog:false,
      vresource:[],
      resource:[],
      search:null,
      rules: {
        required: value => !!value || this.i18n['required'],
        email: value => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(value) || this.i18n['valid_email']
      },
      resourceKeys:[
        { name: 'days', label:'days', type:'select', items:'days', data:['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'], source:'local', fetched:'days',  required: true, multiple:true },
        { name: 'from', label: 'from', type: 'text', fetched: 'from', required: true },
        { name: 'to', label: 'to', type: 'text', fetched: 'to', required: true },
        { name: 'program_id', label:'program', type:'select', items:'programs', source:'db', data:[], required:true },
        { name: 'number', label: 'number', type: 'number', fetched: 'number', required: true },
        { name: 'duration', label: 'duration', type: 'number', fetched: 'duration', required: true },
      ],
      
      resourceSettings:{
        resourceName:null,
        search:true,
        create:true,
        pagination:true,
      },
      newResource:{},
      editing:false,
      deleting:false,
      interviews:[],
      templates:[],
      lists:[],
      types:[],
      units:[],
      generated_user:null,
    }
  },
  
  methods: {
    editLead(r){
      this.dialog = true
      this.editing = true
      this.newResource = r
    },
    async loadItems(){
      return new Promise(async (res, rej)=>{
        let ks = this.resourceKeys.filter(x=>x.type=='select' && x.source == 'db');
        (async x=> {
          for (let i = 0; i < ks.length; i++) {
            const f = ks[i];
            console.log(f.items)
            f.data = this.resource[f.items].map(x=>{
              return {
                ...x,
                text:x.name?x.name:x.en?x.en:'unknown',
                [`${f.name}_id`]:x.id
              }
            })
          }
          res(true)
        })()
      })
    },
    superA(){
      return this.$store.state.user && this.$store.state.user.role == 'superadmin'
    },
    getFormat(d){
      return format(d)
    },
    isNumber(evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if (charCode != 46 && charCode != 45 && charCode != 46 &&
      !(charCode >= 48 && charCode <= 57)) {
        evt.preventDefault();;
      } else {
        return true;
      }
    },
    goTo(path) {
      this.$router.push(path).catch(x=>{})
    },
    async loadResource() {
      return new Promise(async (res, rej)=>{
        this.loading = true
        if(!this.search){
          let r = await this.$store.dispatch('getResource', {resource:this.$route.path})
          r.data = r.data.map(x=>{return {...x, days:x.days.split('|')}})
          this.resource = r
        } else {
          let r = await this.$store.dispatch('searchResource', {resource:this.$route.path + '/search', value:this.search})
          r.data = r.data.map(x=>{return {...x, days:x.days.split('|')}})
          this.resource = r
        }
        this.loading = false
        await this.loadItems()
        res(true)
      })
    },
    async pageByNumber(n){
      return new Promise(async (res, rej)=>{
        this.loading = true
        if(!this.search){
          let r = await this.$store.dispatch('getResource', {resource:this.$route.path, page:`?page=${n}`})
          r.data = r.data.map(x=>{return {...x, days:x.days.split('|')}})
          this.resource = r
        } else {
          let r = await this.$store.dispatch('searchResource', {resource:this.$route.path + `/search?page=${n}`, value:this.search})
          r.data = r.data.map(x=>{return {...x, days:x.days.split('|')}})
          this.resource = r
        }
        this.loading = false
        res(true)
      })
    },
    async searchResource(search){
      return new Promise(async (res, rej)=>{
        this.search = search
        this.loading = true
        this.resource = await this.$store.dispatch('searchResource', {resource:this.$route.path + '/search', value:this.search})
        this.loading = false
        res(true)
      })
    },
    async updateResource(r){
      return new Promise(async (res, rej)=>{
        this.loading = true
        console.log(r)
        await this.$store.dispatch('putResource', {resource:this.$route.path + `/${r.id}`, value:r})
        this.dialog = false
        this.editing = false
        this.loading = false
        await this.loadResource()
        this.newResource = {}
        res(true)
      })
    },
    async deleteResource(r){
      return new Promise(async (res, rej)=>{
        this.loading = true
        await this.$store.dispatch('deleteResource', {resource:this.$route.path + `/${r.id}`})
        this.dialog = false
        this.deleting = false
        this.loading = false
        await this.loadResource()
        this.newResource = {}
        res(true)
      })
    },
    async postResource(r){
      return new Promise(async (res, rej)=>{
        this.loading = true
        console.log(JSON.stringify(r))
        await this.$store.dispatch('postResource', {resource:this.$route.path + `${r.id ? '/' + r.id : ''}`, value:r})
        this.dialog = false
        this.loading = false
        await this.loadResource()
        this.newResource = {}
        res(true)
      })
    },
    setResourceName(){
      this.resourceSettings.resourceName = this.$route.path.replace('/', '')
    }
  },
  watch:{
  },
  computed:{
    de_cities(){
      return this.$store.state.cities
    },
    api(){
      return this.$store.state.settings.apiBase
    },
    users(){
      let sa = this.$store.state.user && this.$store.state.user.role == 'superadmin'
      console.log(sa)
      return this.$store.state.users.filter(x=>{
        if(!sa) {
          return x.superior == this.$store.state.user.level
        } else return x
      })
    },
    site(){
      return this.$store.state.site
    },
    items() {
      return this.$store.state.menu
    },
    superAdmin(){
      return this.$store.state.superAdmin
    },
    isLogin() {
      return this.$store.state.centralLogin
    },
    language(){
      return this.$store.state.language
    },
    globalLoading(){
      return this.$store.state.globalLoading
    },
    user(){
      return this.$store.state.user
    },
    i18n(){
      return this.$store.state.i18n[this.$store.state.language]
    },
    arabic(){
      if(this.$store.state.language == 'ar') return true
    },
    routeTitle(){
      let main = this.$store.state.menu.filter(x=>x.path == this.$route.path)
      let sub = [].concat(...this.$store.state.menu.map(x=>x.subs)).filter(x=>x).filter(x=>x.path == this.$route.path)
      if(main.length) {
        return this.$store.state.i18n[this.$store.state.language][main[0].text]
      } else if(sub.length) {
        return this.$store.state.i18n[this.$store.state.language][sub[0].text]
      } else {
        return ''
      }
    },
    roles(){
      return this.$store.state.userRoles
    },
    notifications(){
      return this.$store.state.notifications.sort((a, b)=> b.timestamp - a.timestamp)
    },
  },
  async created(){
    this.setResourceName()
    await this.loadResource()
    await this.loadItems()
  },
  
}
</script>

<style>
.adminSwitch .v-input {
  margin-top:0 !important;
}
.adminSwitch .v-input__control {
  margin-bottom:0 !important;
}
.adminSwitch .v-label {
  font-size: 12px !important;
}
</style>